import Vue from 'vue'
import Component from 'vue-class-component'
import Api from '@/api'
import { IUser } from '@zunta/configurations'
import { ResidentModule } from '@/store/modules/resident.module'
import { getModule } from 'vuex-module-decorators'

@Component
export class AgingFilterFormsMixin extends Vue {
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  // @ts-ignore
  user: IUser = Api.getUser().data as IUser
  searchValue: string = ''
  isLoading: boolean = false
  focusEl: any = null

  get filtersMap () {
    return this.$store.state.resident.collectionTasksWithAgingFilters
  }

  setSearchValue (value: string) {
    this.searchValue = value
    this.fetchData()
  }

  fetchData () {

  }

  toggleItem (filterType: string, key: string | number, value: any) {
    const filters = { ...this.filtersMap }
    if (!filters[filterType]) {
      filters[filterType] = {}
    }
    if (filters[filterType][key]) {
      delete filters[filterType][key]
    } else {
      filters[filterType][key] = value
    }
    this.residentModuleInstance.setCollectionTaskWithAgingFilters(filters)
  }

  cancel () {
    this.$emit('cancel')
  }

  submit () {
    this.$emit('submit')
  }

  isChecked (filterType: string, filterValue: string) {
    return !!this.filtersMap[filterType] && !!this.filtersMap[filterType][filterValue]
  }
}
